// Load jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('bootstrap');

// 2026 Theme initialization
$(function() {
    'use strict';

    // Preloader
    setTimeout(function() {
        $('.preloader').fadeOut('slow');
    }, 1000);

    // Back to top
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#to-top').fadeIn('slow');
        } else {
            $('#to-top').fadeOut('slow');
        }
    });

    $('#to-top').click(function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
        return false;
    });

    // Smooth scroll for anchor links
    $('a.page-scroll').on('click', function(e) {
        const anchor = $(this);
        const target = $(anchor.attr('href'));
        if (target.length) {
            e.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top - 80
            }, 800);
        }
    });
});
